// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3jgqA","additionalInfo":"AgreementModal_additionalInfo__2534D"};